import Button from "@components/Button";
import { Avatar, Grid, styled, Typography, useTheme } from "@mui/material";
import { useTranslations } from "next-intl";
import SocialLinks from "./components/social-links";
import FormFooter from "./components/form";
import NavLinks from "./components/nav-links";
import PowerBy from "./components/power-by";
import Link from "next/link";
import { CPagesPath } from "shared/models/const/pages-path";

const Footer = () => {
  const translation = useTranslations("footer");
  const theme = useTheme();
  return (
    <FooterRoot container>
      <FooterContainer container justifyContent="space-between" rowSpacing={3}>
        <Grid container item xs={12} md={6} rowGap={3}>
          <Grid
            container
            item
            xs={12}
            spacing={2}
            justifyContent={{
              xs: "center",
              md: "normal",
            }}
          >
            <Grid item xs="auto">
              <Link href={CPagesPath.es.franchises} passHref>
                <Button
                  bg="--color-brand-blue-secondary"
                  thin_button
                  component="a"
                >
                  {translation("openFranchise")}
                </Button>
              </Link>
            </Grid>
            <Grid item xs="auto">
              <Link href={CPagesPath.es.join} passHref>
                <Button
                  bg="--color-brand-blue-secondary"
                  thin_button
                  component="a"
                >
                  {translation("joinRemax")}
                </Button>
              </Link>
            </Grid>
            <Grid item xs="auto">
              <Link href={CPagesPath.es.frequent_questions} passHref>
                <Button bg="--color-brand-red-main" thin_button component="a">
                  {translation("faq")}
                </Button>
              </Link>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid item xs={12} md={9}>
              <Typography
                variant="body2"
                color="var(--color-text-secondary)"
                sx={{
                  [theme.breakpoints.down("md")]: {
                    textAlign: "center",
                  },
                }}
              >
                {translation("about")}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} md={"auto"}>
            <Avatar
              src="/images/v2/logos/9.png"
              alt="Logo Re/max"
              sx={{
                width: 450,
                height: "auto",
                objectFit: "contain",
                [theme.breakpoints.down("md")]: {
                  width: 200,
                  margin: "0 auto",
                },
              }}
              variant="square"
            />
          </Grid>
          <Grid item xs={12} marginTop={5}>
            <SocialLinks />
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          md={5}
          textAlign={{
            xs: "center",
            md: "left",
          }}
        >
          <Grid container rowGap={2} flexDirection="column">
            <Grid item xs={"auto"}>
              <Typography
                variant="h6"
                fontSize={"25px"}
                color="var(--color-text-secondary)"
              >
                {translation("form.title")}
              </Typography>
            </Grid>

            <Grid item xs={"auto"}>
              <Typography
                variant="body2"
                fontSize={"14px"}
                color="var(--color-text-secondary)"
              >
                {translation("form.subscribe")}
              </Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <FormFooter />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <NavLinks />
        </Grid>
      </FooterContainer>
      <PowerBy />
    </FooterRoot>
  );
};

export default Footer;

const FooterRoot = styled(Grid)(({ theme }) => ({}));

const FooterContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: "var(--color-brand-blue-main)",
  padding: "3rem 3rem 0rem 7rem",
  borderRadius: "0 200px 0 0",
  [theme.breakpoints.down("md")]: {
    borderRadius: "0",
    padding: "3rem 1rem 0rem 1rem",
  },
}));
